import { createContext, useContext } from 'react';

const MessageThreadCheckContext = createContext(false);

export const useThreadView = () => useContext(MessageThreadCheckContext);

export const MessageThreadCheckProvider = MessageThreadCheckContext.Provider;
